import React from "react";
import { HeartHandshake, Sparkles, ShieldCheck, MapPin } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";

const cards = [
  {
    icon: HeartHandshake,
    title: "Atendimento personalizado",
    desc: "Cada pessoa é única. Escutamos com atenção para cuidar de você de forma individual e acolhedora.",
  },
  {
    icon: ShieldCheck,
    title: "Profissionais qualificados",
    desc: "Cuidado sério e responsável em saúde e estética, com técnica e dedicação em cada detalhe.",
  },
  {
    icon: Sparkles,
    title: "Ambiente acolhedor",
    desc: "Um espaço tranquilo e elegante, pensado para o seu bem-estar do início ao fim da experiência.",
  },
  {
    icon: MapPin,
    title: "Localização acessível",
    desc: "Fácil acesso na Vila Guarani, em Jundiaí-SP, para caber com conforto na sua rotina.",
  },
];

export const Differentials = () => {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative py-24 md:py-36 bg-gradient-to-b from-clinic-pinkSoft/40 via-clinic-pinkSoft/60 to-clinic-pinkSoft/40"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <Overline index="02">Diferenciais</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-clinic-ink">
              Por que escolher a <span className="italic text-clinic-rose font-normal">Lília Targa</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.title} delay={i * 0.08}>
                <div
                  data-testid={`differential-card-${i}`}
                  className="group relative h-full bg-white/90 backdrop-blur-sm rounded-3xl border border-clinic-line/70 p-8 transition-all duration-400 hover:-translate-y-2 hover:shadow-soft-lg hover:border-clinic-rose/50 hover:bg-white flex flex-col justify-between"
                >
                  <div>
                    <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-clinic-pinkSoft text-clinic-rose transition-all duration-300 group-hover:bg-clinic-rose group-hover:text-white group-hover:scale-110 shadow-sm">
                      <Icon className="h-6 w-6" strokeWidth={1.75} />
                    </div>
                    <h3 className="mt-6 font-serif text-2xl text-clinic-ink leading-snug font-medium">
                      {c.title}
                    </h3>
                    <p className="mt-3 font-sans text-sm text-clinic-muted leading-relaxed">
                      {c.desc}
                    </p>
                  </div>
                  
                  {/* Subtle Accent Bottom Line on Hover */}
                  <div className="mt-6 h-1 w-0 bg-clinic-rose/60 rounded-full transition-all duration-300 group-hover:w-12" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

